import styled from "styled-components";
import { Row as AntRow } from "antd";

export const RootContainer = styled.div`
  padding: 0 16px;
`;

export const Title = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
  padding-top: 6px;
  padding-bottom: 6px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: #000000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #D9D9D9;
  border-radius: 16px;
`;

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  grid-gap: 8px;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  @media screen and (max-width: 325px) {
    grid-gap: 6px;
    padding: 6px 0px;
  }
`;

export const Text = styled.div`
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: #000;
  text-align: center;
`;

export const Image = styled.img.attrs({
  alt: "img",
})`
  width: 100%;
  max-width: 68px;
  border-radius: 10px;
  aspect-ratio: 1;
  object-fit: contain;
  border: 1px solid #E5E0F5;

  @media screen and (max-width: 325px) {
    max-width: 55px;
  }
`;

export const SpinWrapper = styled.div`
  height: calc(100vh - 70px);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Row = styled(AntRow)`
  padding: 16px 0px;
  border-radius: 10px;
`;